<nf-grid-wrapper
  *nfLoader="callingExchange"
  [hideSearch]="true"
  [hideClearAll]="true"
>
  <nf-grid-wrapper-header-left>
    <h2 class="title">Positions</h2>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right>
    <div class="d-flex">
      <div id="quickfilter-container" class="d-flex justify-content-end mr-2">
        <nf-checkbox
          class="small"
          [formControl]="showOnlyDifferencesToggle"
          label="Only Differences"
        ></nf-checkbox>
        <nf-checkbox
          class="small"
          [formControl]="showOnlyIncorrectToggle"
          label="Only Incorrect"
        ></nf-checkbox>
      </div>
      <div class="d-flex justify-content-end">
        <nf-form-control compact for="quickSearchAssetIds">
          <input
            type="text"
            class="form-control"
            [formControl]="quickSearchAssetIds"
            placeholder="Asset Ids (e.g. 1,2,3)"
          />
        </nf-form-control>
        <ng-grid-wrapper-header-right>
          <div ngbDropdown placement="bottom-right">
            <button
              ngbDropdownToggle
              nf-icon-button
              class="positions-actions-button"
              ngbTooltip="Positions Actions"
              placement="bottom-right"
              icon="dots-vertical"
              style="margin-left: 8px"
            >
              Positions Actions
            </button>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdown"
              class="dropdown-menu dropdown-menu-right"
            >
              <button
                type="button"
                class="dropdown-item btn btn-link"
                (click)="exportPositionsToExcel()"
              >
                Export to Excel
              </button>
              <button
                *ngIf="
                  (availableActionsPermissions | async)
                    ?.canTransferOutAllPositionsOneSided
                "
                type="button"
                class="dropdown-item btn btn-link"
                (click)="transferOutAllPositions('oneSided')"
              >
                Transfer Out All Positions (One-Sided)
              </button>
              <button
                *ngIf="
                  (availableActionsPermissions | async)
                    ?.canTransferOutAllPositionsDirect
                "
                type="button"
                class="dropdown-item btn btn-link"
                (click)="transferOutAllPositions('direct')"
              >
                Transfer Out All Positions (Direct)
              </button>
            </div>
          </div>
        </ng-grid-wrapper-header-right>
        <button
          nf-icon-button="secondary"
          ngbTooltip="Filters Modal"
          placement="bottom-right"
          icon="filter"
          (click)="launchFiltersModal()"
          data-cy="advancedFiltersBtn"
        >
          Open Filters Modal
        </button>
        <div class="position-relative">
          <hs-applied-filter-counts
            [filterCount]="filterCount"
          ></hs-applied-filter-counts>
          <button
            id="reset-all-filters-button"
            nf-icon-button="secondary"
            ngbTooltip="Reset Filters"
            icon="filter-remove"
            (click)="resetFilters()"
            class="filter-button ml-0"
            [disabled]="!resetFiltersEnabled"
            placement="bottom-right"
          >
            Reset All Filters to Default
          </button>
        </div>
      </div>
    </div>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content *ngIf="gridOptions$ | async as gridOptions">
    <nf-table-layout
      [hideTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [autoResizeGrid]="false"
      hideSearch
      hideClearAll
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
